import Joi from 'joi';

import { generateJoiValidation } from '@/shared/validations/generateJoiValidation';
import { Team } from '@/modules/teams/teams.model';
import { objectId } from '@/shared/validations/custom.validation';

export const createTeam = () => ({
  body: generateJoiValidation(Team.schema),
});

export const updateTeam = () => ({
  query: Joi.object().keys({
    id: Joi.string().custom(objectId).required(),
  }),
  body: generateJoiValidation(Team.schema, true),
});

export const getTeam = {
  query: Joi.object().keys({
    name: Joi.string(),
    team: Joi.string(),
    sortBy: Joi.string(),
    search: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    companyId: Joi.string(),
    includeTimeStamps: Joi.boolean(),
  }),
};

export const getTeamById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};

export const deleteTeamById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};
